document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (event) => {
    const clickedSwatch = event.target.closest("[data-custom-option-value]");
    if (!clickedSwatch) {
      return;
    }
    const parentLi = clickedSwatch.closest("[data-prod-card]");
    if (!parentLi) {
      return;
    }

    // Remember which color the shopper picked on the card so the hover
    // "Choose Options" button can pre-select it in the quick-view drawer.
    // Size is intentionally not tracked — only the color option is carried over.
    const swatchValue = clickedSwatch.getAttribute("data-swatch-value");
    if (swatchValue) {
      parentLi.dataset.selectedColor = swatchValue;
      // Visual selection state: clear siblings, mark the clicked one.
      parentLi
        .querySelectorAll("[data-custom-option-value].is-selected")
        .forEach((el) => el.classList.remove("is-selected"));
      clickedSwatch.classList.add("is-selected");
    }

    const imageElement = parentLi.querySelector("[data-product-image-main]");
    const imageElement2 = parentLi.querySelectorAll(
      "[data-product-image-second]",
    );
    if (!imageElement) {
      return;
    }
    const variantImage = clickedSwatch.getAttribute("variant-image");
    if (!variantImage) {
      return;
    }
    const variantSecondImage = clickedSwatch.getAttribute(
      "variant-second-image",
    );
    const srcset = `
      ${variantImage};width=165 165w,
      ${variantImage};width=360 360w,
      ${variantImage};width=533 533w,
      ${variantImage};width=720 720w,
      ${variantImage};width=940 940w,
      ${variantImage};width=1066 1066w,
      ${variantImage} 2688w
    `.trim();
    imageElement.src = variantImage;
    if (variantSecondImage) {
      const srcsetSecond = `
        ${variantSecondImage};width=165 165w,
        ${variantSecondImage};width=360 360w,
        ${variantSecondImage};width=533 533w,
        ${variantSecondImage};width=720 720w,
        ${variantSecondImage};width=940 940w,
        ${variantSecondImage};width=1066 1066w,
        ${variantSecondImage} 2688w
      `.trim();
      imageElement2.forEach((img) => {
        img.src = variantSecondImage;
        img.srcset = srcsetSecond;
      });
    } else {
      imageElement2.forEach((img) => {
        img.src = variantImage;
        img.srcset = srcset;
      });
    }
    imageElement.srcset = srcset;
  });
});
